import { type TypedUseSelectorHook, useSelector as useAppSelector } from 'react-redux'
import { type RootState } from 'services'

const useSelector: TypedUseSelectorHook<RootState> = useAppSelector

export default useSelector
